var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBox = function SvgBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.55 6.208a2.233 2.233 0 0 0-.492-.85 2 2 0 0 0-.541-.441l-5.367-3.1a2.312 2.312 0 0 0-2.3 0l-5.367 3.1a2 2 0 0 0-.541.441 2.233 2.233 0 0 0-.492.85 2.11 2.11 0 0 0-.108.692v6.2c0 .817.433 1.575 1.141 1.983l5.367 3.1a2.355 2.355 0 0 0 1.15.308c.183 0 .367-.024.542-.066a2.11 2.11 0 0 0 .608-.242l5.367-3.1a2.288 2.288 0 0 0 1.141-1.983V6.9a2.11 2.11 0 0 0-.108-.692ZM9.483 2.9c.159-.092.334-.142.517-.142s.358.05.517.142l5.266 3.033L10 9.275 4.217 5.933 9.483 2.9ZM4.108 14a1.04 1.04 0 0 1-.516-.9V7.017l5.783 3.35v6.675L4.108 14Zm12.3-.9c0 .375-.2.717-.516.9l-5.267 3.042v-6.675l5.783-3.35V13.1Z",
    fill: "current"
  })));
};
export default SvgBox;